// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__KzSwy","itemsWrapper":"styles_itemsWrapper__UZmc1","item":"styles_item__JG3eX","download":"styles_download__2uFba"};